import React, {useContext} from 'react';
import PropTypes from 'prop-types';

// Material UI
import Grid from "@mui/material/Grid";


// Components
import BeatLoaderRegular from "components/loaders/BeatLoaderRegular";

// Local components
import IconContainer from "./components/IconContainer";

// Assets
import {greyishBlue100, greyishBlue500, red50} from "assets/jss/main";
import { ReactComponent as ScanLogo } from "assets/img/wms/scan.svg";
import { ReactComponent as DeliveryLogo } from "assets/img/wms/delivery.svg";
import { ReactComponent as BoxLogo } from "assets/img/wms/box.svg";
import { ReactComponent as ShelfLogo } from "assets/img/wms/shelf.svg";

// Utils
import {WMSRoutes} from "utils/WMSRoutes";

// Context
import {WMSContext} from "views/wms/context/WMSContext";

MissionResumeItem.propTypes = {
    count: PropTypes.number.isRequired,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    type: PropTypes.oneOf([
        'pickup', // wmsItem
        'sort',  // wmsItem
        'pack', // wmsItem
        'ship', // wmsItem
        'tri_shipping', // shipment
        'reception_cc', // shipment
        'cc_hand_over' // shipment
    ]).isRequired,
    loading: PropTypes.bool
};

function MissionResumeItem({count, text, type, loading = false}) {
    const { redirect} = useContext(WMSContext)

    function getIconByType(type) {
        switch (type) {
            case 'pickup':
                return <IconContainer color={red50}><ScanLogo /></IconContainer>
            case 'sort':
                return <IconContainer color={'#C9E7FF'}><ShelfLogo /></IconContainer>
            case 'pack':
            case 'tri_shipping':
            case 'reception_cc':
            case 'cc_hand_over':
                return <IconContainer color={'#E5DEFF'}><BoxLogo /></IconContainer>
            case 'ship':
                return <IconContainer color={'#FFE9B2'}><DeliveryLogo /></IconContainer>
            default:
                return null;
        }
    }

    function getLinkByType(type) {
        switch (type) {
            case 'pickup':
                return WMSRoutes.PICKING;
            case 'sort':
                return WMSRoutes.SORTING;
            case 'pack':
                return WMSRoutes.PACKING;
            case 'ship':
                return WMSRoutes.SHIPPING;
            case 'tri_shipping':
                return WMSRoutes.TRI_SHIPPING;
            case 'reception_cc':
                return WMSRoutes.CC_RECEPTION_LIST;
            case 'cc_hand_over':
                return WMSRoutes.CC_HAND_OVER;
            default:
                return null;
        }
    }
    return (
        <Grid
            container
            justifyContent={'space-between'}
            onClick={() => redirect(getLinkByType(type))}
            sx={{
                background: 'white',
                border: `1px solid ${greyishBlue100}`,
                borderRadius: '8px',
                padding: '16px'
            }}
        >
            <Grid item container xs={10} alignItems={'center'}>
                <Grid item>
                    {getIconByType(type)}
                </Grid>
                <Grid
                    item
                    marginLeft={1}
                    sx={{
                        fontSize: '14px',
                        color: greyishBlue500,
                        fontWeight: 600,
                    }}
                >
                    {text}
                </Grid>
            </Grid>
            {loading ? (
                <BeatLoaderRegular loading={true} size={10} />
            ) : (
                <Grid
                    item
                    xs={2}
                    textAlign={'end'}
                    sx={{
                        fontSize: '24px',
                        fontWeight:' 700',
                    }}
                >
                    {count}
                </Grid>
            )}
        </Grid>
    );
}

export default MissionResumeItem;
